module.exports = __webpack_public_path__ + "media/images/sales_crm-ccf8712a288197ff5a94ac36758a76d6.ico";